import React, {ReactElement, useEffect, useMemo} from 'react';
import Header from "./common/Header";
import Wrapper from "./Wrapper";
import {userAPI} from "../api/user";
import {useAppSelector} from "../store/hooks";
import {useSearchParams} from "react-router-dom";

const Page = ({children}: {children: ReactElement}) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const authUser = useAppSelector(state => state.auth.authUser)
    const isSearchMode = searchParams.get('mode') === 'search'
    userAPI.useGetOptionsQuery()

    return (
        <Wrapper>
            {(!isSearchMode && !authUser?.isTester) && <Header />}
            {children}
        </Wrapper>
    )
};

export default Page;